module.exports = __webpack_public_path__ + "static/img/home-logo.bd8fd17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexPage/home/home-logo.png
// module id = c5kI
// module chunks = 51